.
<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <dashboard />
    </v-container>
  </div>
</template>

<script>
import Dashboard from "../components/DashboardDs9/Dashboard.vue";
import LandingToolbar from "../components/LandingToolbar/LandingToolbar.vue";
export default {
  components: { Dashboard, LandingToolbar },
};
</script>
